// COMMUNITY LANDING PAGE
export const RESET_COMMUNITY_INFORMATIONS = '@landingPage/ResetCommunityInformations'
export const GET_COMMUNITY_INFORMATIONS_BY_INVITATION_LINK_REQUEST =
  '@landingPage/GetCommunityInformationsByInvitationLinkRequest'
export const GET_COMMUNITY_INFORMATIONS_BY_INVITATION_LINK_SUCCESS =
  '@landingPage/GetCommunityInformationsByInvitationLinkSuccess'
export const GET_COMMUNITY_INFORMATIONS_BY_INVITATION_LINK_FAILURE =
  '@landingPage/GetCommunityInformationsByInvitationLinkFailure'
